export default __webpack_public_path__ + "static/media/co.94d61041.png";